import { selectAuth, selectMerchant } from "@redux";
import { useEffect, useState } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

interface IProps {
    accessToken: any;
    usePostForm: boolean;
}
export const ComponentPopupHomePage = (props: IProps) => {
    const { accessToken, usePostForm } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);
    const { auth, userInfo, merchant_prefix } = useSelector(selectAuth);
    const [openShowPopup, setOpenShowPopup] = useState(false);
    const merchant = useSelector(selectMerchant);

    const popupHomePage = sessionStorage.getItem("popupHomePage");

    useEffect(() => {
        if (!popupHomePage) {
            if (accessToken) {
                if (
                    userInfo?.contact?.sellerId &&
                    merchant?.themes?.sellerThemeSetting?.homePagePopup?.image
                ) {
                    setOpenShowPopup(true);
                    sessionStorage.setItem("popupHomePage", "true");
                } else if (!userInfo?.contact?.sellerId && merchant?.themes?.linkImageUrl) {
                    setOpenShowPopup(true);
                    sessionStorage.setItem("popupHomePage", "true");
                } else if (
                    userInfo?.contact?.sellerId &&
                    merchant?.themes?.sellerThemeSetting?.homePagePopup?.image === ""
                ) {
                    setOpenShowPopup(false);
                    sessionStorage.setItem("popupHomePage", "false");
                } else if (!userInfo?.contact?.sellerId && merchant?.themes?.linkImageUrl === "") {
                    setOpenShowPopup(false);
                    sessionStorage.setItem("popupHomePage", "false");
                } else {
                    sessionStorage.setItem("popupHomePage", "false");
                }
            }
        } else if (usePostForm) {
            sessionStorage.setItem("popupHomePage", "false");
        } else if (popupHomePage === "false") {
            if (accessToken) {
                if (
                    userInfo?.contact?.sellerId &&
                    merchant?.themes?.sellerThemeSetting?.homePagePopup?.image !== ""
                ) {
                    setOpenShowPopup(true);
                    sessionStorage.setItem("popupHomePage", "true");
                } else if (!userInfo?.contact?.sellerId && merchant?.themes?.linkImageUrl !== "") {
                    setOpenShowPopup(true);
                    sessionStorage.setItem("popupHomePage", "true");
                } else if (
                    userInfo?.contact?.sellerId &&
                    merchant?.themes?.sellerThemeSetting?.homePagePopup?.image === ""
                ) {
                    setOpenShowPopup(false);
                    sessionStorage.setItem("popupHomePage", "false");
                } else if (!userInfo?.contact?.sellerId && merchant?.themes?.linkImageUrl === "") {
                    setOpenShowPopup(false);
                    sessionStorage.setItem("popupHomePage", "false");
                } else {
                    sessionStorage.setItem("popupHomePage", "false");
                }
            }
        }
    }, [accessToken, popupHomePage, usePostForm, merchant, userInfo]);

    return (
        <>
            {openShowPopup && (
                <>
                    {!merchant?.themes?.isSellerTheme ? ( /// ถ้าเป็น customer
                        <StyledPopupRedeem>
                            <div className="box-popupconfirm">
                                <img
                                    src={merchant?.themes?.linkImageUrl}
                                    alt=""
                                    onClick={() => window.open(merchant?.themes?.linkUrl, "_self")}
                                />
                                <div
                                    className="box-close"
                                    onClick={() => {
                                        setOpenShowPopup(false);
                                    }}
                                >
                                    <IoIosCloseCircleOutline size={30} color={themes?.themeColor} />
                                </div>
                            </div>
                        </StyledPopupRedeem>
                    ) : (
                        <>
                            {merchant?.themes?.isSellerTheme && (
                                <>
                                    {!userInfo?.contact?.sellerId ? ( /// ถ้าเป็น Seller และไม่มี sellerId
                                        <StyledPopupRedeem>
                                            <div className="box-popupconfirm">
                                                <img
                                                    src={merchant?.themes?.linkImageUrl}
                                                    alt=""
                                                    onClick={() =>
                                                        window.open(
                                                            merchant?.themes?.linkUrl,
                                                            "_self"
                                                        )
                                                    }
                                                />
                                                <div
                                                    className="box-close"
                                                    onClick={() => {
                                                        setOpenShowPopup(false);
                                                    }}
                                                >
                                                    <IoIosCloseCircleOutline
                                                        size={30}
                                                        color={themes?.themeColor}
                                                    />
                                                </div>
                                            </div>
                                        </StyledPopupRedeem>
                                    ) : (
                                        /// ถ้าเป็น Seller และมี sellerId
                                        <StyledPopupRedeem>
                                            <div className="box-popupconfirm">
                                                <img
                                                    src={
                                                        merchant?.themes?.sellerThemeSetting
                                                            ?.homePagePopup?.image
                                                    }
                                                    alt=""
                                                    onClick={() =>
                                                        window.open(
                                                            merchant?.themes?.sellerThemeSetting
                                                                ?.homePagePopup?.link,
                                                            "_self"
                                                        )
                                                    }
                                                />
                                                <div
                                                    className="box-close"
                                                    onClick={() => {
                                                        setOpenShowPopup(false);
                                                    }}
                                                >
                                                    <IoIosCloseCircleOutline
                                                        size={30}
                                                        color={themes?.themeColor}
                                                    />
                                                </div>
                                            </div>
                                        </StyledPopupRedeem>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 100px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
`;
